module.exports = __webpack_public_path__ + "img/9791158880774.27b55132.jpg";